import React, { useState, useContext } from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

type StateType = {
  open: boolean;
  message: string;
};

const initialState = {
  open: false,
  message: '',
};

type SnackbarContextType = {
  openSnackbar: (message: string) => void;
};

const contextDefaultValues: SnackbarContextType = {
  openSnackbar: () => {},
};

const SnackbarContext = React.createContext<SnackbarContextType>(contextDefaultValues);

const useStyles = makeStyles((theme) => ({
  snackbar: {
    backgroundColor: theme.palette.error.main,
    borderRadius: '16px',
    padding: '16px 32px',

    '& p': {
      color: theme.palette.error.contrastText,
    },
  },
}));

const SnackbarProvider: React.FC = ({ children }) => {
  const classes = useStyles();
  const [state, setState] = useState<StateType>(initialState);

  const context = {
    openSnackbar: (message: string) => {
      setState({
        open: true,
        message,
      });
    },
  };

  const handleClose = (event: React.SyntheticEvent | React.MouseEvent, reason?: string) => {
    if (reason === 'clickaway') return;
    setState(initialState);
  };

  return (
    <SnackbarContext.Provider value={context}>
      {children}
      <Snackbar open={state.open} onClose={handleClose} autoHideDuration={5000}>
        <div className={classes.snackbar}>
          <Typography>{state.message}</Typography>
        </div>
      </Snackbar>
    </SnackbarContext.Provider>
  );
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useSnackbar = () => useContext(SnackbarContext);

export default SnackbarProvider;
